import React, { useState, useEffect,Component } from 'react';
// import API from '../../../utils/apiCalling';
// import { config } from '../../../utils/apiUrl';
import { get } from 'lodash';
import MQSGUtil from "../../../components/mqsgUtil";
import { Link } from 'react-router-dom';
import moment from 'moment';
import AdvertBox from "../../../components/advert/advert";
const WarrantMarketTurnOver = (props) => {

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])


  const [marketTurnOverAll, setMarketTurnOverAll] = useState([])

  useEffect(() => {
    getMarketTurnOverResult()
    document.title = "Index futures rollover | Singapore Warrants | Macquarie"
  }, [])
  const getMarketTurnOverResult = async () => {
    const url = MQSGUtil.getAPIBasePath() + "/IndexFuturesRollover";
        fetch(url)
          .then((res) => res.json())
          .then(
            (result) => {
              console.log(result)
               setMarketTurnOverAll(result)
            }
          );
  }

  return (
    <div id="dwturnover" className="pageobj">
      <h1 id="ric" style={{ display: "none" }} />
      <div className="breadcrumbbar">
        <div className="container-fluid">
          <ol className="breadcrumb">
            <li>
              <Link to="/home?dwstat">Warrant education</Link>
            </li>
            <li className="active">Index futures rollover</li>
          </ol>
        </div>
      </div>
      <div className="stripe-bg" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-8">
            <div className="section">
              <div className="page-header">
                <h1>Index futures rollover</h1>
              </div>
              <p style={{fontSize:'13px'}}>
              The table below lists the dates when the relevant futures contracts are expected to roll over to the following contract month. Please note that these dates are indicative only and may be updated periodically.
              </p>
              <div id="totalTbl" className="tbl">
                <table className="table table-striped table-closed">
                  <thead>
                    <tr>
                      <th>Index underlying</th>
                      <th>Current futures contract month</th>
                      <th>Tracks next futures contract month from</th>
                    </tr>
                  </thead>
                  <tbody>
                    {marketTurnOverAll &&
                      marketTurnOverAll.map(
                        (turnOverAllData, turnOverAllIndex) => (
                          <tr
                            className="rowtmpl"
                            key={turnOverAllIndex}
                            idx={turnOverAllIndex}
                          >
                            <td className="stats_date_obj">
                              {turnOverAllData.underlying}
                            </td>
                            <td className="total">{turnOverAllData.month}</td>
                            <td className="dw">{ turnOverAllData.date}</td>
                          </tr>
                        )
                      )}
                  </tbody>
                </table>
              </div>
                  <div style={{float:'right',fontSize:'13px',marginBottom: '20px'}}>
                    Last update :{" "}
                    <span>{moment().format("DD MMM YY")}</span>
                  </div>
              <p style={{fontSize:'13px',clear:'both'}}>Macquarie’s index warrants track the relevant futures contract month and not the index level. This is because we hedge our positions by buying and selling the associated futures contracts, which expire on set dates. Consequently, the index warrants must roll over to track the new contract month accordingly. For Hang Seng Index (HSI), Hang Seng TECH Index (HSTECH) and FBM KLCI warrants, the contract month is updated on a monthly basis. For Nikkei 225 Index (NIKKEI) and U.S. index warrants, the contract month is updated on a quarterly basis.</p>
              
            </div>
          </div>
          <div className="col-md-4">
            <AdvertBox />
            <Search />
            <Terms />
            <Calculator />
          </div>
        </div>
      </div>
    </div>
  );
}
class Search extends Component {
  constructor() {
    super();
  }
  render() {
    return (
      <div className="section qlink-section">
        <div className="page-header">
          <h2 className="small">Warrant search</h2>
        </div>
        <p className="section-p">
          Find warrants according to your investment criteria. For more
          information on how to select a warrant, click{" "}
          <a href="/tools/warrantsearch">here</a>
        </p>
        <div className="section-qlink-img section-qlink-dwsearch">
          <Link to="/tools/warrantsearch" className="section-qlink-achor">
            <img src="/img/bullet/qlink-achor.png" />
          </Link>
        </div>
      </div>
    );
  }
}

class Terms extends Component {
  render() {
    return (
      <div className="section qlink-section">
        <div className="page-header">
          <h2 className="small">Warrant terms</h2>
        </div>
        <p className="section-p">
          All the key parameters and terms about your selected warrants are
          found here.
        </p>
        <div className="section-qlink-img section-qlink-dwterm">
          <Link to="/tools/warrantterms" className="section-qlink-achor">
            <img src="/img/bullet/qlink-achor.png" />
          </Link>
        </div>
      </div>
    );
  }
}

class Calculator extends Component {
  render() {
    return (
      <div className="section qlink-section">
        <div className="page-header">
          <h2 className="small">Warrant calculator</h2>
        </div>
        <p className="section-p">
          Estimates the theoretical price of a warrant based on your input of
          the underlying price, time, or implied volatility.
        </p>
        <div className="section-qlink-img section-qlink-dwcalculator">
          <Link
            to="/tools/warrantcalculator"
            className="section-qlink-achor"
          >
            <img src="/img/bullet/qlink-achor.png" />
          </Link>
        </div>
      </div>
    );
  }
}
export default WarrantMarketTurnOver;
